import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {
password: string = '';
  confirmPassword: string = '';
  loading = false;
  isWrongMatch = false;
  isConnected: boolean = navigator.onLine;
  token: string;
  redirectType;
  constructor(
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private authService: AuthenticationService,
    private router: Router,
  ) {
   }

  matchPassword(event: any) {
    event.preventDefault();
    if (this.password !== this.confirmPassword) {
      this.isWrongMatch = true;
    } else {
      this.isWrongMatch = false;
    }
  }

    isEmpty(string1: any) {
        if (!string1 || string1 === null || string1 === undefined || string1 === 'undefined' || string1 === 'null' || string1 == '') {
          return true;
        }
        return false;
    }

  resetPassword() {
    console.log(this.token);
    if (this.isEmpty(this.password)) {
      this.toastr.warning('Error', 'Please enter Password before saving.');
      return;
    }
    if (this.isEmpty(this.confirmPassword)) {
      this.toastr.warning('Error', 'Please Confirm Password before saving.');
      return;
    }
    if (this.password != this.confirmPassword) {
      this.toastr.warning('Error', 'Password and Confirm Password should be same.');
      return;
    }
    this.isConnected = navigator.onLine;
    this.loading = true;
    const options = {
        password: this.password.trim(),
        token: this.token
    };
    this.authService.resetPassword(options).subscribe(
      (response: any) => {
        if (response.status === 'success') {
          this.toastr.success('Success', 'Password reset successful. Redirecting..');
          setTimeout(() => {
              this.router.navigate(['login']);
          }, 1500);
        } else if (response.status === 'fail') {
          this.toastr.error('Fail', response.message);
          this.loading = false;
        }
      },
      (error: any) => {
        this.errorMessage(error);
      }
    );
  }

  errorMessage(error: any) {
    this.loading = false;
    if (!this.isConnected) {
      this.toastr.error('No Internet', 'Check internet');
    } else {
      this.toastr.error('Error', 'Server Error');
    }
  }
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
    });
  }

}
